__turbopack_context__.v({
  "className": "gilroy_a5d8da8e-module__8DRLrG__className",
});
